
<template>
  <div>
    <!-- 销售统计详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="详细信息"
      :visible.sync="seeInfoVisible"
      :before-close="seeInfoHandleClose"
      width="55.4%"
      center
    >
      <el-divider></el-divider>
      <div class="titleXstj">
        <el-date-picker
          v-model="value1"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-button @click="DetailBtns">查询</el-button>
        <el-button class="Dcb" @click="exportBtns">导出报表</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="CreateTime" label="时间"></el-table-column>
          <el-table-column prop="Name" label="分销商名称"></el-table-column>
          <el-table-column prop="OrderNumber" label="订单号"></el-table-column>
          <el-table-column prop="Count" label="购买数量"></el-table-column>
          <el-table-column prop="Mobile" label="接收号码"></el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 销售统计详情弹框结束 -->
  </div>
</template>

<script>
import { DisOrderDetail } from '@/request/scenic.js'
import { readExcelToJson, saveJsonToExcel } from '@/request/xlx.js'
export default {
  props:['noteId'],
  data() {
    return {
      seeInfoVisible: false, // 销售统计详情
      tableData: [
       
      ],
      value1: "",
      options: [
      ],
      data:{
        token:window.sessionStorage.getItem('Token'),
        distributorid:'',
        starttime:'',
        endtime:'',
        page:1,
        page_size:8
      },
      total:0      
    };
  },
  created(){
    this.data.distributorid = this.noteId
    this.Detail()
  },
  methods: {
    // 导出
    exportBtns(){
      saveJsonToExcel(this.tableData, 'data.xlsx')
    },
    // 查询
    DetailBtns(){
      this.data.page = 1
      this.total = 0
      if(this.value1){
        this.data.starttime = this.value1[0] + ' 00:00:00'
        this.data.endtime = this.value1[1] + ' 23:59:59'
      }else{
        this.data.starttime = ''
        this.data.endtime = ''
      }
      this.Detail()
    },
    // 分页
    handleCurrentChange(e){
      this.data.page = e
      this.Detail()
    },
    Detail(){
      DisOrderDetail(this.data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.total = res.data.result.total
          this.tableData = res.data.result.data
        }
      })
    },
    // 查看详情
    noteInfo() {
      this.seeInfoVisible = true;
    },
    // 查看详情X
    seeInfoHandleClose() {
      this.seeInfoVisible = false;
      this.$emit('noteClose')
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.titleXstj {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    // font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
  .Dcb {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    margin-left: 20px
  }
}
.titleXstj /deep/ input{
  color: #666 !important;
}
.titleZxtj {
  margin-bottom: 20px;
  .el-button {
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-left: 20px;
  }
}
.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-form-item__label {
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: right;
  color: #666666;
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/.el-dialog{
  min-width: 400px;
}
</style>